(function () {
  'use strict';

  var PRODUCT_INFO_SELECTOR = 'product-info[id^="MainProduct"]';
  var PRICE_ROOT_SELECTOR = '[id^="Price-"]';
  var GPO_CONTAINER_SELECTOR = '.gpo-container';
  var GPO_TOTAL_SELECTOR = '.gpo-total .money';
  var initialized = new WeakSet();

  function getProductInfo() {
    return document.querySelector(PRODUCT_INFO_SELECTOR);
  }

  function getPriceRoot(productInfo) {
    return productInfo && productInfo.querySelector(PRICE_ROOT_SELECTOR);
  }

  function getBasePrice(productInfo, state) {
    var priceRoot = getPriceRoot(productInfo);
    var priceMarkup = priceRoot && priceRoot.querySelector('[data-broadcast-price-cents]');
    var markupPrice = priceMarkup && Number(priceMarkup.dataset.broadcastPriceCents);

    if (Number.isFinite(markupPrice)) {
      state.basePriceCents = markupPrice;
    }

    return Number.isFinite(state.basePriceCents) ? state.basePriceCents : null;
  }

  function parseGloboMoney(value) {
    var text = String(value || '').trim();

    if (!text) return 0;

    var numeric = text.replace(/\s/g, '').replace(/[^0-9,.-]/g, '');
    if (!numeric) return 0;

    var comma = numeric.lastIndexOf(',');
    var dot = numeric.lastIndexOf('.');

    if (comma !== -1 && dot !== -1) {
      if (comma > dot) {
        numeric = numeric.replace(/\./g, '').replace(',', '.');
      } else {
        numeric = numeric.replace(/,/g, '');
      }
    } else if (comma !== -1) {
      numeric = numeric.replace(',', '.');
    }

    var amount = Number(numeric);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function getGloboAddonTotal(productInfo) {
    var total = productInfo && productInfo.querySelector(GPO_TOTAL_SELECTOR);
    return total ? parseGloboMoney(total.textContent) : 0;
  }

  function formatAmount(cents, decimals, thousandsSeparator, decimalSeparator) {
    var amount = (cents / 100).toFixed(decimals).split('.');
    var integer = amount[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    return decimals ? integer + decimalSeparator + amount[1] : integer;
  }

  function fallbackFormatMoney(cents, format) {
    var token = (String(format || '').match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    var formatted;

    switch (token) {
      case 'amount_no_decimals':
        formatted = formatAmount(cents, 0, ',', '');
        break;
      case 'amount_with_comma_separator':
        formatted = formatAmount(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatAmount(cents, 0, '.', '');
        break;
      case 'amount_with_space_separator':
        formatted = formatAmount(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = formatAmount(cents, 0, ' ', '');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = formatAmount(cents, 2, "'", '.');
        break;
      case 'amount_with_period_and_space_separator':
        formatted = formatAmount(cents, 2, ' ', '.');
        break;
      default:
        formatted = formatAmount(cents, 2, ',', '.');
    }

    return String(format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }

  function formatMoney(cents, priceMarkup) {
    var freeText = priceMarkup && priceMarkup.dataset.broadcastFreeText;
    var format = priceMarkup && priceMarkup.dataset.broadcastMoneyFormat;

    if (cents === 0 && freeText) return freeText;

    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents, format || window.theme.moneyFormat);
    }

    return fallbackFormatMoney(cents, format);
  }

  function updateBroadcastPrice(productInfo, state) {
    var priceRoot = getPriceRoot(productInfo);
    var priceMarkup = priceRoot && priceRoot.querySelector('[data-broadcast-price-cents]');
    var basePrice = getBasePrice(productInfo, state);

    if (!priceRoot || !priceMarkup || basePrice === null) return;

    var finalPrice = basePrice + getGloboAddonTotal(productInfo);
    var formattedPrice = formatMoney(finalPrice, priceMarkup);
    var salePrice = priceRoot.querySelector('.price__sale .price-item--sale');
    var regularPrice = priceRoot.querySelector('.price__regular > .price-item--regular');
    var targetPrice = salePrice || regularPrice;

    if (targetPrice && targetPrice.textContent.trim() !== formattedPrice) {
      targetPrice.textContent = formattedPrice;
    }

    productInfo.querySelectorAll('[data-product-price]').forEach(function (element) {
      if (element.closest(PRICE_ROOT_SELECTOR)) return;

      var compareAtPrice = element.querySelector('s');

      if (compareAtPrice) {
        var compareAtPriceClone = compareAtPrice.cloneNode(true);
        element.innerHTML = formattedPrice + ' ';
        element.appendChild(compareAtPriceClone);
      } else if (element.innerHTML.trim() !== formattedPrice) {
        element.innerHTML = formattedPrice;
      }
    });
  }

  function startForProduct(productInfo) {
    if (!productInfo || initialized.has(productInfo)) return;
    initialized.add(productInfo);

    var state = {
      basePriceCents: null,
      frame: null,
      gpoContainer: null,
      gpoObserver: null
    };

    function sync() {
      state.frame = null;
      updateBroadcastPrice(productInfo, state);
    }

    function scheduleSync() {
      if (state.frame !== null) return;
      state.frame = window.requestAnimationFrame(sync);
    }

    function attachGpoObserver() {
      var gpoContainer = productInfo.querySelector(GPO_CONTAINER_SELECTOR);
      if (!gpoContainer || gpoContainer === state.gpoContainer) return;

      if (state.gpoObserver) state.gpoObserver.disconnect();
      state.gpoContainer = gpoContainer;
      state.gpoObserver = new MutationObserver(scheduleSync);
      state.gpoObserver.observe(gpoContainer, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'value', 'checked']
      });
      scheduleSync();
    }

    var productObserver = new MutationObserver(function () {
      attachGpoObserver();
    });

    productObserver.observe(productInfo, { childList: true, subtree: true });
    attachGpoObserver();
    scheduleSync();

    document.addEventListener('change', function (event) {
      if (!event.target.closest || !event.target.closest('.gpo-element')) return;
      if (!productInfo.contains(event.target)) return;
      scheduleSync();
    }, true);

    document.addEventListener('input', function (event) {
      if (!event.target.closest || !event.target.closest('.gpo-element')) return;
      if (!productInfo.contains(event.target)) return;
      scheduleSync();
    }, true);

    if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (payload) {
        var data = payload && payload.data;
        var sectionId = productInfo.dataset.sectionId || productInfo.dataset.section;

        if (data && data.sectionId && data.sectionId !== sectionId) return;

        if (data && data.variant && Number.isFinite(Number(data.variant.price))) {
          state.basePriceCents = Number(data.variant.price);
        }

        scheduleSync();
      });
    }
  }

  function start() {
    startForProduct(getProductInfo());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
